<div class="container p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Cadastro de Usuário</h1>

  <form class="space-y-4">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <!-- Linha 1 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <label for="nome" class="mb-1 font-medium text-gray-700">Usuário</label>
        <input pInputText id="nome" type="text" placeholder="Nome de usuário" [(ngModel)]="usuario.username" name="nome" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <label for="senha" class="mb-1 font-medium text-gray-700">Senha</label>
        <div class="password-field relative">
          <input pInputText id="senha" [type]="showPassword ? 'text' : 'password'" placeholder="Senha" [(ngModel)]="usuario.password" name="senha" class="w-full p-component rounded border-gray-300" autocomplete="new-password" />
          <button type="button" class="password-toggle" (click)="toggleShowPassword()" aria-label="Alternar exibição de senha">
            <i [ngClass]="showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Linha 2: Roles -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 flex flex-col">
        <label class="mb-1 font-medium text-gray-700">Roles</label>
        <div class="flex flex-wrap items-center gap-4 mt-2">
          <label *ngFor="let r of rolesOptions" class="inline-flex items-center space-x-2">
            <input type="checkbox" [checked]="usuario.roles?.includes(r)" (change)="toggleRole(r)" class="h-4 w-4" />
            <span>{{ r }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Linha 3: Botões -->
    <div class="flex flex-wrap gap-4 pt-4">
      <button pButton type="button" class="btn btn-primary btn-md" [disabled]="!canSubmit || isSubmitting" (click)="salvar()">
        <i class="pi pi-check mr-2"></i>
        <span>{{ isSubmitting ? (editMode ? 'Salvando...' : 'Cadastrando...') : (editMode ? 'Salvar' : 'Cadastrar') }}</span>
      </button>
      <button *ngIf="editMode" pButton type="button" class="btn btn-secondary btn-md" (click)="cancelarEdicao()">
        <i class="pi pi-times mr-2"></i>
        <span>Cancelar</span>
      </button>
      <button *ngIf="!editMode" pButton type="button" class="btn btn-secondary btn-md" (click)="limparFormulario()">
        <i class="pi pi-eraser mr-2"></i>
        <span>Limpar</span>
      </button>
    </div>
  </form>

  <div class="overflow-x-auto">
    <p-table [value]="usuarios" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Usuário</th>
          <th class="p-2 border-b text-left">Roles</th>
          <th class="p-2 border-b text-left">Situação</th>
          <th class="p-2 border-b text-left">Data Cadastro</th>
          <th class="p-2 border-b text-left">Data Última Modificação</th>
          <th class="p-2 border-b text-left">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-usuario>
        <tr>
          <td class="p-2 border-b">{{ usuario.id }}</td>
          <td class="p-2 border-b">{{ usuario.username }}</td>
          <td class="p-2 border-b">{{ usuario.roles?.join(', ') || '-' }}</td>
          <td class="p-2 border-b">
            <ng-container *ngIf="usuario.ativo !== false; else notActive">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Ativo</span>
            </ng-container>
            <ng-template #notActive>
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">Desativado</span>
            </ng-template>
          </td>
          <td class="p-2 border-b">{{ usuario.dataCadastro | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td class="p-2 border-b">{{ usuario.dataUltimaModificacao | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td class="p-2 border-b">
            <div class="flex items-center space-x-1">
              <button pButton type="button" class="p-button-text p-button-sm text-gray-700" title="Editar usuário" (click)="editar(usuario)">
                <i class="pi pi-pencil"></i>
              </button>
              <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="usuario.ativo ? 'text-red-600' : 'text-green-600'" [title]="usuario.ativo ? 'Desativar usuário' : 'Ativar usuário'" (click)="confirmarRemover(usuario)">
                <i [ngClass]="usuario.ativo ? 'pi pi-ban text-red-600' : 'pi pi-user-plus text-green-600'"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
